import React from 'react'
import { useState } from 'react'
import { useEffect } from 'react'
import { DeletePageApi, getPagesListApi } from '../../API/AdminServices'
import Style from './PageList.module.css'
import ThreeHorseLoading from 'react-loadingg/lib/ThreeHorseLoading'
import Table from '../../Components/Table/Table'
import Modal from '../../Components/Modal/Modal'
import { errorToast, succToast } from '../../Toast/Toast'
const PagesList = () => {
    const[pageList,setPageList]=useState()
    useEffect(()=>{
        getPagesList()
    },[])
    const getPagesList=async()=>{
        const data=await getPagesListApi()
        setPageList(data.pages)
    }
    const[purchased,setPurchased]=useState(false)
    const[pageName,setPageName]=useState()

    const closeModalHandler=()=>{
        setPurchased(false)
    }
    const showModalHandler=(name)=>{
        setPageName(name)
        setPurchased(true)
    }

    const DeletePageHandler=()=>{
        let info={
            page:pageName
        }
        DeletePageApi(info,(succ)=>{
            if(succ.status===1){
                succToast(succ.message)
                setPurchased(false)
                getPagesList()
            }
            else{
                errorToast(succ.message)
            }
        })
    }
    const HeaderTable=[
        'شماره',
        'نام صفحه',
        'آدرس',
        'ویرایش'
    ]
    let loadingHandler=null
    if(pageList===undefined){
        loadingHandler= <div className={Style.LoadingHolder}><ThreeHorseLoading /></div>
    }
    else{
        loadingHandler=<div className={Style.TableHolder}><Table data={pageList} thHeader={HeaderTable} openModal={showModalHandler}/></div>
    }
    return (
        <div className={Style.PageHolder}>
            <Modal show={purchased} modalClose={closeModalHandler} translate={30}>
            <div className={Style.ModalCheker}>
                    <p>آیا از حذف صفحه اطمینان دارید؟</p>
                    <div className={Style.AnswerHolder}>
                        <p className={Style.YesAnswer} onClick={DeletePageHandler}>بله</p>
                        <p className={Style.NoAnswer} onClick={closeModalHandler}>خیر</p>
                    </div>
                </div>
            </Modal>
            <div className={Style.ImageHolder}><img src="/Assets/Images/Panel/PageList.svg" alt="barber" /></div>
            {
                loadingHandler
            }
        </div>
    )
}

export default PagesList
